import { render, staticRenderFns } from "./OnboardingDashboard.vue?vue&type=template&id=333319f1&scoped=true&"
import script from "./OnboardingDashboard.vue?vue&type=script&lang=js&"
export * from "./OnboardingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDashboard.vue?vue&type=style&index=0&id=333319f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333319f1",
  null
  
)

export default component.exports